/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetDetailedHealthRequest {
    sessionId?: string;
}

/**
 * MonitoringApi - interface
 * 
 * @export
 * @interface MonitoringApiInterface
 */
export interface MonitoringApiInterface {
    /**
     * Retrieves detailed health information about the system
     * @summary Get system health
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringApiInterface
     */
    getDetailedHealthRaw(requestParameters: GetDetailedHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * Retrieves detailed health information about the system
     * Get system health
     */
    getDetailedHealth(requestParameters: GetDetailedHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

}

/**
 * 
 */
export class MonitoringApi extends runtime.BaseAPI implements MonitoringApiInterface {

    /**
     * Retrieves detailed health information about the system
     * Get system health
     */
    async getDetailedHealthRaw(requestParameters: GetDetailedHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/monitoring/health`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves detailed health information about the system
     * Get system health
     */
    async getDetailedHealth(requestParameters: GetDetailedHealthRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getDetailedHealthRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
